import CustomizableGeneric from './CustomizableGeneric';

class ItemList extends CustomizableGeneric {
  getTypeName = () => 'ImageObject';

  getFields = () => ['url'];
}

export default ItemList;
